var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectDropDown',{attrs:{"id":_vm.id,"name":_vm.name,"label":_vm.label,"options":_vm.statuses,"defaultSelected":_vm.statuses[0]},on:{"selection-change":_vm.generalStatusSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }